import React from 'react';

import PropTypes from 'prop-types';

import { FlexColumn } from 'ui-components/components/flex';

import style from './return-details-grid-layout.module.less';

export const ReturnDetailsGridLayout = ({ className, addressColumnContent, dateColumnContent, rmaColumnContent }) => {
  return (
    <div className={className}>
      <FlexColumn className={style['address-column']}>{addressColumnContent}</FlexColumn>
      <FlexColumn className={style['dates-column']}>{dateColumnContent}</FlexColumn>
      <FlexColumn className={style['rma-column']}>{rmaColumnContent}</FlexColumn>
    </div>
  );
};

ReturnDetailsGridLayout.propTypes = {
  className: PropTypes.string,
  addressColumnContent: PropTypes.node.isRequired,
  dateColumnContent: PropTypes.node.isRequired,
  rmaColumnContent: PropTypes.node.isRequired,
};
